import React, {MouseEvent, useCallback} from 'react';

import {useLocalesMgr} from 'coreHooks';
import {Link} from 'coreUtils/adapters/router';
import {absoluteUrl} from 'coreUtils/url';
import {getIsInternalUrl} from 'coreUtils/url';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

import {ILinkProps} from './ILink';

const LocalizedLink = ({to, children, isController, onClick, ref, ...props}: ILinkProps) => {
	const localesMgr = useLocalesMgr();
	const {managerRepository} = useGeneralProvider();
	const isExternalApp = managerRepository.getConfigurationsMgr().get('isCORSRequest');
	const thirdPartyRequestURL = isExternalApp
		? absoluteUrl(isController ? to : localesMgr.updateLinkWithLocale(to))
		: null;
	// Should be passed '#' for external app to cover a case with SFCC links
	const externalURL = !getIsInternalUrl(isExternalApp ? '#' : to) ? to : thirdPartyRequestURL;

	const handlerCloseFlyout = useCallback(
		(event: MouseEvent<HTMLAnchorElement>) => {
			event.stopPropagation();

			if (onClick) {
				onClick(event);
			} else if (location.pathname === to) {
				managerRepository.getFlyoutsMgr().closeAllFlyouts();
			}
		},
		[onClick, to, managerRepository],
	);

	// If it is link from external app, should be an absolute url
	if (externalURL) {
		return (
			<a href={externalURL} onClick={handlerCloseFlyout} {...props} ref={ref}>
				{children}
			</a>
		);
	}

	return (
		<Link
			ref={ref}
			to={isController ? to : localesMgr.updateLinkWithLocale(to)}
			onClick={handlerCloseFlyout}
			{...props}
		>
			{children}
		</Link>
	);
};

export default LocalizedLink;
